/* Restore the eligible one/two-accessory offer after Shopify checkout keeps
   only the winning code. Eligibility and prices remain enforced by Shopify. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.init(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  function offerCodes(cart) {
    var products = new Set((cart.items || []).map(function (item) { return String(item.product_id); }));
    var codes = [];
    (cart.discount_codes || []).forEach(function (discount) {
      var match = /^SURI-LOOK-(\d+)-(10K|14K|VERMEIL|SILVER)-[12]$/i.exec(discount.code);
      if (!match) codes.push(discount.code);
      else if (products.has(match[1])) {
        var prefix = 'SURI-LOOK-' + match[1] + '-' + match[2].toUpperCase() + '-';
        codes.push(prefix + '1', prefix + '2');
      }
    });
    // A private line property survives checkout removing inapplicable codes.
    // It is hidden from shoppers; Shopify still checks the qualifying purchase.
    (cart.items || []).forEach(function (item) {
      var prefix = item.properties && item.properties._suri_complete_look;
      var match = typeof prefix === 'string' && /^SURI-LOOK-(\d+)-(10K|14K|VERMEIL|SILVER)$/i.exec(prefix);
      if (match && products.has(match[1])) codes.push(prefix.toUpperCase() + '-1', prefix.toUpperCase() + '-2');
    });
    return Array.from(new Set(codes));
  }
  function init(view) {
    if (view.suriLookCartReady) return;
    view.suriLookCartReady = true;
    var document = view.document;
    var rootUrl = view.Shopify && view.Shopify.routes ? view.Shopify.routes.root : '/';
    var pending = null;
    var queued = false;
    var lastError = false;
    var hasLook = false;
    function showError() {
      var target = document.getElementById('CartDrawer-CartErrors') || document.getElementById('cart-errors');
      if (target) target.textContent = 'We could not refresh your matching price. Please try checkout again.';
    }
    function sync() {
      queued = true;
      if (pending) return pending;
      pending = (async function () {
        try {
          do {
            queued = false;
            var response = await view.fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
            if (!response.ok) throw new Error('Cart unavailable');
            var cart = await response.json();
            var existing = (cart.discount_codes || []).map(function (discount) { return discount.code; });
            var codes = offerCodes(cart);
            hasLook = existing.concat(codes).some(function (code) { return /^SURI-LOOK-/i.test(code); });
            if (!hasLook) continue;
            if (existing.join(',').toUpperCase() === codes.join(',').toUpperCase()) continue;
            response = await view.fetch(rootUrl + 'cart/update.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ discount: codes.join(',') })
            });
            if (!response.ok) throw new Error('Offer unavailable');
            var updated = await response.json();
            if (updated.status) throw new Error('Offer unavailable');
            if (updated.total_price !== cart.total_price) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
            }
          } while (queued);
          lastError = false;
          return true;
        } catch (error) {
          lastError = hasLook;
          if (hasLook) showError();
          return !hasLook;
        } finally { pending = null; }
      })();
      return pending;
    }
    document.addEventListener('cart:change', sync);
    view.addEventListener('pageshow', function (event) { if (event.persisted) sync(); });
    // Wait for a cart edit's price reconciliation before submitting checkout.
    var resuming = false;
    document.addEventListener('click', async function (event) {
      var button = event.target.closest('[name="checkout"], #CartDrawer-Checkout, a[href="/checkout"]');
      if (!button || resuming || (!pending && !lastError)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!await (pending || sync())) return;
      var next = button.id && document.getElementById(button.id) || button;
      resuming = true;
      try { next.click(); } finally { resuming = false; }
    }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
    else sync();
  }
  return { offerCodes: offerCodes, init: init };
});
